import axios from "axios";
import Env from "@/logics/Envs.js";

export default function (store) {
    store.commit("setSchool", null);
    store.commit("setUser", null);
    store.commit("setTimer", null);
    axios.get(Env.freePath + "logout");
}